import './Button.css';

export default function Button(props: any) {
    return <button className="Button"
        onClick={props.onClick}
        disabled={props.disabled}>

        {props.children}
    </button>;
}